import styles from './UIGameCount.module.scss'
import {PlayerColor} from '@colonist/game-states'
// eslint-disable-next-line no-restricted-imports
import {getImagePath} from '../../../../../code/client/shared/scripts/ui_utils/Utils'

function getBackgroundImage(color: PlayerColor) {
    const colorName = PlayerColor[color].toLowerCase()
    const filename = `button_badge_background_${colorName}.svg`
    return getImagePath(filename)
}

export interface UIGameCountProps {
    count: number
    color: PlayerColor
}

export function UIGameCount({
    count,
    color,
}: UIGameCountProps) {
    const backgroundImageSrc = getBackgroundImage(color)

    return <div className={styles.container}>
        <img className={styles.backgroundImage} src={backgroundImageSrc} />
        <div className={styles.count}>{count}</div>
    </div>
}
